import React, { Fragment } from 'react';
import './DefineDataGroup.css'
import { FusePageSimple } from '@fuse';
import { withStyles } from '@material-ui/core/styles';
import DefinitionControls from "./DefinitionControls";
import AggregatesTable from "./AggregatesTable";
import DimensionsTable from "./DimensionsTable";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Cookies from 'universal-cookie'
import classNames from 'classnames';
import PropTypes from 'prop-types'
import { Prompt } from 'react-router'
import jstimezonedetect from "jstimezonedetect";
import axiosInstance from "../common/AxiosInstace";
import history from "../../../history";
import EndpointsGetter from '../common/EndpointsGetter';
import CircularProgress from '@material-ui/core/CircularProgress';
import trim from 'lodash/trim';
import mapKeys from 'lodash/mapKeys';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import FormLabel from '@material-ui/core/FormLabel';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import axiosIntervalInstance from '../common/AxiosIntervalInstance';

const styles = theme => ({
    textArea: {
        fontSize: 17 + 'px !important'
    },
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto', 'top': '50%', 'left': '50%'
    }
});

const cookies = new Cookies();

class DefineDataGroup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            //Create data group request parameters
            dataGroupParams: {},
            aggregates: {},
            dimensions: {},
            sampleData: "",
            aggTypes: {},
            timezones: [],
            timeBuckets: [],
            attributes: [],
            editDataGroup: {},
            accountParameters: {},
            sampleDataValue: "",
            editMode: false,
            groupId: null,
            groupUrl: null,
            userId: null,
            accountId: null,
            records: null,
            realTimeInterval: 5,
            accessToken: null,
            savedGroupData: {
                name: "",
                status: "active",
                timezone: "",
                aggregationTimeBuckets: [
                    { id: 1, value: "minute", label: "Minute" },
                    { id: 2, value: "hour", label: "Hour" },
                    { id: 3, value: "day", label: "Day" },
                    { id: 4, value: "week", label: "Week" },
                    { id: 5, value: "month", label: "Month" },
                    { id: 6, value: "quarter", label: "Quarter" }
                ],
                attributesAndAggregationTypes: [],
                aggregationDimensions: [],
                sampleData: ""
            },
            sampleDataChanged: false,
            unsavedChanges: false,
            navigationBlocked: PropTypes.bool.isRequired,
            isUserInputsValid: true,
            errorString: '',
            invalidDataFormatMessage: '',
            invalidFormatAreaStyle: {},
            show: false,
            modalMessage: '',
            forbidAllActions: false,
            editModal: false,
            editStatusProgramatically: false,
            dataGroupStatus: '',
            modalAction: '',
            replayableRecords: 0,
            aggregationsLimit: 0,
            dimensionsLimit: 0
        }
    }

    async componentDidMount() {
        let accessToken = localStorage.getItem("access_token");
        if (accessToken == null || typeof accessToken == "undefined") {
            history.push('/login');
        } else {
            this.setAccountDetails();
            this.setAllAggregationTypes();
            this.setAllTimeZones();

            let pathParts = this.props.location.pathname.split('/'),
                operation = pathParts[1],
                id = pathParts[2];
            if (operation == 'edit-group') {
                if (typeof id == 'undefined' || isNaN(id) || id == '') {
                    history.push('/create-group');
                } else {
                    if (this.props.history.location.message != null && this.props.history.location.message != 'undefined') {
                        let oldState = { ...this.state };
                        oldState.modalMessage = this.props.location.message;
                        oldState.show = true;
                        this.setState(oldState);
                        this.props.location.message = null;
                    }
                    this.getDataGroup(id);
                    const response = await this.getDataGroupReplayStats(id, false);
                    if (response) this.setState({ replayableRecords: response.replayableRecords });
                }
            } else if (operation == 'create-group') {
                if (typeof id != 'undefined') {
                    history.push('/create-group');
                }
                let oldState = { ...this.state };
                oldState.editMode = false;
                oldState.editDataGroup = {};
                this.setState(oldState);
            }
            this.setState(this);
            this.forceUpdate();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);

        let deleteDataModal = document.getElementById('deleteDataModal');
        let deleteGroupModal = document.getElementById('deleteGroupModal');
        if (document.body.contains(deleteDataModal)) {
            deleteDataModal.remove();
        }
        if (document.body.contains(deleteGroupModal)) {
            deleteGroupModal.remove();
        }
    }

    onUnload(event) {
        event.returnValue = "Unsaved changes. Are you sure you want to leave?";
    }

    getDataGroup(groupId) {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getDataGroupEndpoint() + '/' + groupId, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.accessToken = accessToken;
                oldState.editMode = true;
                oldState.records = response.data.records;
                oldState.groupId = response.data.id;
                oldState.editDataGroup = response.data;
                oldState.editDataGroup["url"] = this.state.groupUrl;
                oldState.editDataGroup["records"] = response.data.records;
                oldState.editDataGroup["editMode"] = true;
                oldState.editDataGroup["securityToken"] = response.data.securityKey;
                oldState["realTimeInterval"] = response.data.realTimeInterval === null ? 5 : response.data.realTimeInterval;

                //account params 
                oldState.accountParameters["securityToken"] = response.data.securityKey;

                oldState.sampleDataValue = response.data.sampleData;
                oldState.savedGroupData = cloneDeep(response.data);
                if (response.data.status === 'inactive' && response.data.records === 0) {
                    oldState.editDataGroup.editMode = false;
                }

                this.setState(oldState);
                this.setAttributesAndSampleData();
                this.setAggregates(response.data);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    // polling functionality's limit needs to be set correctly, currently we are doing upto 20 api requests every two seconds
    // I'll need to change that value to a more accurate one, depending on sheer volume of data, that is being deleted or replayed.
    pollingForReplayStats = (groupId) => {
        let timesToPoll = 0;
        const pollingData = async () => {
            if (++timesToPoll < 20) {
                const response = await this.getDataGroupReplayStats(groupId, true);
                if (response && response.replayableRecords === 0)
                    setTimeout(pollingData, 1500);
                else if (response && response.replayableRecords !== 0)
                    this.setState({ replayableRecords: response.replayableRecords });
            }
        }
        setTimeout(pollingData, 1500);
    }

    getDataGroupReplayStats = async (groupId, polling) => {
        const accessToken = localStorage.getItem("access_token"),
            instanceToUse = polling ? axiosIntervalInstance : axiosInstance;
        try {
            const response = await instanceToUse.get(`${EndpointsGetter.getDataGroupReplayStatsEndpoint()}/${groupId}`, {
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                }
            });
            return response.data;

        } catch (err) {
            this.getError(err);
        }
    }

    setAggregates = ({ attributesAndAggregationTypes, aggregationDimensions }) => {
        this.setState({
            aggregates: {
                attributesAndAggregationTypes: attributesAndAggregationTypes,
                unsavedChanges: false
            },
            dimensions: {
                aggregationDimensions: aggregationDimensions,
                unsavedChanges: false
            }
        });
    }

    setAllAggregationTypes() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getAggTypesEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };

                oldState.aggTypes = response.data;
                oldState.accessToken = accessToken;
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setAllTimeZones() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getTimezonesEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let newState = { ...this.state };
                newState.timezones = response.data;
                newState.accessToken = accessToken;

                if (this.state.savedGroupData.timezone == '') {
                    let timezoneName = jstimezonedetect.determine().name();
                    let fullTimezoneName = response.data.find(zone => {
                        return zone.includes(timezoneName)
                    });
                    let newSavedGroupData = this.state.savedGroupData;
                    newSavedGroupData.timezone = fullTimezoneName;

                    newState.savedGroupData = newSavedGroupData
                }

                this.setState(newState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setAccountDetails() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getAccountDetailsEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.groupUrl = response.data.accountUrl;
                oldState.userId = response.data.userId;
                oldState.accountId = response.data.accountId;
                oldState.accessToken = accessToken;
                oldState.aggregationsLimit = response.data.aggregationsLimit
                oldState.dimensionsLimit = response.data.dimensionsLimit
                oldState.accountParameters["url"] = response.data.accountUrl;

                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    createDataGroup(userData) {
        let qs = require('qs');
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.post(EndpointsGetter.getDataGroupEndpoint(), qs.parse(userData), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(createResponse => {
                window.history.pushState("", "", '/edit-group/' + createResponse.data.id);
                let oldState = { ...this.state };
                oldState.editDataGroup = createResponse.data;
                oldState.editDataGroup["url"] = this.state.groupUrl;
                oldState.editDataGroup["records"] = createResponse.data.records;
                oldState.editDataGroup["editMode"] = true;
                oldState.editDataGroup["securityToken"] = createResponse.data.securityKey;
                oldState.sampleDataValue = createResponse.data.sampleData;
                oldState.groupId = createResponse.data.id;
                oldState.editMode = true;
                oldState.modalMessage = "Group has been created successfully";
                oldState.show = true;
                oldState.savedGroupData = cloneDeep(createResponse.data);

                oldState.unsavedChanges = false;
                oldState.aggregatesDataChanged = false;
                oldState.dimensionsDataChanged = false;
                oldState.basicDataChanged = false;
                oldState.sampleDataChanged = false;
                window.removeEventListener("beforeunload", this.onUnload);

                this.setState(oldState);
                this.setAttributesAndSampleData();
            })
            .catch(error => {
                this.getError(error);
            });
    }

    updateDataGroup(userData, status) {
        let qs = require('qs');
        let accessToken = localStorage.getItem("access_token");
        let promiseResult = axiosInstance.put(EndpointsGetter.getDataGroupEndpoint(), qs.parse(userData), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(updateResponse => {
                let oldState = { ...this.state };
                oldState.editDataGroup = updateResponse.data;
                oldState.editDataGroup["url"] = this.state.groupUrl;
                oldState.editDataGroup["records"] = updateResponse.data.records;
                oldState.editDataGroup["editMode"] = true;
                oldState.editDataGroup["securityToken"] = updateResponse.data.securityKey;
                oldState.sampleDataValue = updateResponse.data.sampleData;
                oldState.savedGroupData = cloneDeep(updateResponse.data);

                oldState.unsavedChanges = false;
                oldState.aggregatesDataChanged = false;
                oldState.dimensionsDataChanged = false;
                oldState.basicDataChanged = false;
                oldState.sampleDataChanged = false;
                if (status) {
                    oldState.editStatusProgramatically = true; oldState.dataGroupStatus = 'active';
                } else {
                    oldState.modalMessage = "Group has been updated successfully"; oldState.show = true;
                }
                if (updateResponse.data.status === 'inactive' && updateResponse.data.records === 0) {
                    oldState.editDataGroup['editMode'] = false;
                }
                window.removeEventListener("beforeunload", this.onUnload);

                this.setState(oldState);
                this.setAttributesAndSampleData();
                return updateResponse.data;
            })
            .catch(error => {
                this.setState({ forbidAllActions: false });
                this.getError(error);
            });

        return promiseResult;
    }

    deleteDataGroup(params) {
        let accessToken = localStorage.getItem("access_token");
        this.setState({
            forbidAllActions: true
        });
        const deleteApiUrl = `${EndpointsGetter.getDataGroupEndpoint()}/${params.id}?dataOnly=${params.dataOnly}${params.deleteRecorderData ?
            `&recorderData=${params.deleteRecorderData}` : ``}`;
        let deletePromise = axiosInstance.delete(deleteApiUrl, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(({ data }) => {
                if (params.dataOnly) {
                    let oldState = { ...this.state };
                    if (data.deleted) {
                        oldState.modalMessage = "Delete process finished with success";
                        oldState.editDataGroup["records"] = 0;
                        oldState.records = 0;
                        if (oldState.editDataGroup.status === 'inactive' && oldState.editDataGroup.records === 0)
                            oldState.editDataGroup.editMode = false;
                    } else {
                        oldState.modalMessage = "Unable to delete the data group in appropriate time.";
                        oldState.editDataGroup.editMode = true;
                    }
                    oldState.show = true;
                    oldState.forbidAllActions = false;

                    this.setState(oldState);
                    if (!params.deleteRecorderData) this.pollingForReplayStats(data.id);
                } else {
                    params.props.history.push({
                        pathname: '/data-groups',
                        message: 'Delete process finished with success'
                    });
                }
            })
            .catch(error => {
                this.setState({ forbidAllActions: false });
                this.getError(error);
            });

        return deletePromise;
    }

    cloneDataGroup(params) {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.post(EndpointsGetter.getDataGroupEndpoint() + '/' + params.id, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                params.props.history.push({
                    pathname: '/data-groups',
                    message: 'Group has been cloned successfully',
                    groupName: response.data.name
                });
            })
            .catch(error => {
                this.getError(error);
            });
    }

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                history.push('/login');
            }
        }
        let oldState = { ...this.state };
        oldState.isUserInputsValid = false;
        oldState.errorString = errorString;
        this.setState(oldState);
    }

    handleSampleDataChange(evt) {
        let oldState = { ...this.state };
        oldState.sampleDataValue = evt.target.value;
        if (oldState.savedGroupData != null && typeof oldState.savedGroupData != 'undefined') {
            try {
                let parsedData = JSON.parse(evt.target.value);
                oldState.sampleDataChanged = !isEqual(oldState.savedGroupData.sampleData != '' ? JSON.parse(oldState.savedGroupData.sampleData) : {}, parsedData);
                this.setState(oldState);
                this.checkForUnsavedChanges();
            } catch (e) {
                if (oldState.savedGroupData.sampleData != '') {
                    oldState.sampleDataChanged = true;
                    this.setState(oldState);
                    this.checkForUnsavedChanges()
                }
            }
        }
        this.setState(oldState);
    }

    setAttributesAndSampleData() {
        if (typeof this.state.sampleDataValue != "undefined" && this.state.sampleDataValue != "") {
            try {
                let oldState = { ...this.state },
                    parsedData = JSON.parse(this.state.sampleDataValue),
                    trimmedParsedData = mapKeys(parsedData, (value, key) => { return trim(key) });
                if (Object.keys(trimmedParsedData).filter(key => key === "").length) {
                    throw new Error('Error!');
                }
                if (this.state.savedGroupData != null && typeof this.state.savedGroupData != 'undefined') {
                    oldState.sampleDataChanged = !isEqual(this.state.savedGroupData.sampleData != '' ? JSON.parse(this.state.savedGroupData.sampleData) : {}, parsedData);
                    this.checkForUnsavedChanges();
                }
                if (isEmpty(trimmedParsedData)) {
                    oldState.editDataGroup.aggregationDimensions = [];
                    oldState.editDataGroup.attributesAndAggregationTypes = [];
                    oldState.savedGroupData.aggregationDimensions = [];
                    oldState.savedGroupData.attributesAndAggregationTypes = [];
                    oldState.aggregates = {};
                    oldState.dimensions = {};
                }
                oldState.attributes = Object.keys(trimmedParsedData);
                oldState.sampleData = JSON.stringify(trimmedParsedData);
                oldState.sampleDataValue = JSON.stringify(trimmedParsedData, null, 4);
                oldState.invalidFormatAreaStyle = {};
                oldState.invalidDataFormatMessage = '';
                this.setState(oldState);
            } catch (e) {
                let oldState = { ...this.state };
                oldState.invalidDataFormatMessage = 'Invalid data format';
                oldState.invalidFormatAreaStyle = { border: '2px solid red' };
                oldState.sampleData = "";
                oldState.attributes = [];
                this.setState(oldState);
            }
        } else {
            let oldState = { ...this.state };
            oldState.sampleData = "";
            oldState.attributes = [];
            this.setState(oldState);
        }
    }

    handleSampleDataBlur(evt) {
        this.setAttributesAndSampleData();
    }

    sanitizeUserInput(string) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;',
            "(": '&#x28;',
            ")": '&#x29;',
        };
        const reg = /[&<>"'/()]/ig;
        return string.replace(reg, (match) => (map[match]));
    }

    clientLimitExceeded(type, number) {
        this.setState({
            errorString: type + ' limit reached. Cannot create more than ' + number + ' ' + type,
            isUserInputsValid: false
        });
    }

    validateUserInput(userData) {
        if (userData.name != null && typeof userData.name != 'undefined' && userData.name.length != 0) {
            userData.name = userData.name.trim();
        }
        if (userData.name != null && typeof userData.name != 'undefined' && userData.name.length == 0) {
            this.state.errorString = 'Name field is required! Cannot be empty!';
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.name != null && typeof userData.name != 'undefined' && userData.name.length > 50) {
            this.state.errorString = 'Name exceeds the maximum length of 50!';
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.name !== null && typeof userData.name !== 'undefined') {
            let format = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
            if (format.test(userData.name)) {
                this.state.errorString = "Name can only contain alphanumeric characters, spaces, '`', '_' and '-'";
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        //userData.name = encodeURI(userData.name);
        //userData.name = this.sanitizeUserInput(userData.name);
        if (userData.status != null && typeof userData.status != 'undefined' && (userData.status != 'active' && userData.status != 'inactive')) {
            this.state.errorString = "Invalid value for data group status!";
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.timezone != null && typeof userData.timezone != 'undefined' && this.state.timezones.indexOf(userData.timezone) == -1) {
            this.state.errorString = "Invalid value for data group timezone!";
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.aggregationTimeBuckets != null && typeof userData.aggregationTimeBuckets != 'undefined' && (userData.aggregationTimeBuckets.length < 1)) {
            this.state.errorString = "You should select at least one aggregation time bucket!";
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.aggregationTimeBuckets != null && typeof userData.aggregationTimeBuckets != 'undefined' && (userData.aggregationTimeBuckets.length > 9)) {
            this.state.errorString = "Invalid value for aggregation time buckets!";
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.sampleData != null && typeof userData.sampleData != 'undefined' && userData.sampleData.length < 1) {
            this.state.errorString = "Sample data field is empty or consists invalid data!";
            this.state.isUserInputsValid = false;
            return false;
        }
        if (userData.attributesAndAggregationTypes != null && typeof userData.attributesAndAggregationTypes != 'undefined') {
            if (userData.attributesAndAggregationTypes.length < 1) {
                this.state.errorString = "You should define at least one aggregate and its type of aggregation!";
                this.state.isUserInputsValid = false;
                return false;
            }

            let result = userData.attributesAndAggregationTypes.filter(function (a) {
                let key = a.attribute + '|' + a.aggregationTypeId;
                if (!this[key]) {
                    this[key] = true;
                    return true;
                }
            }, Object.create(null));

            if (result.length != userData.attributesAndAggregationTypes.length) {
                this.state.errorString = "Duplicated rows in the table of attributes and aggregation types!";
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (userData.aggregationDimensions !== null && typeof userData.aggregationDimensions !== 'undefined') {
            if (userData.aggregationDimensions.length < 1) {
                this.state.errorString = "You should define at least one aggregation dimension!";
                this.state.isUserInputsValid = false;
                return false;
            }

            let dimensionsObjects = [...userData.aggregationDimensions];

            for (let dim of dimensionsObjects) {
                if (dim.dimensions.length !== new Set(dim.dimensions).size) {
                    this.state.errorString = "Duplicated aggregation dimensions for a single type of aggregation!";
                    this.state.isUserInputsValid = false;
                    return false;
                }
            }

            let hash = {};
            let out = [];

            for (let dim of dimensionsObjects) {
                let key = dim.dimensions.sort().join(',');
                if (!hash[key]) {
                    out.push(dim.dimensions);
                    hash[key] = 'found';
                }
            }

            if (out.length != dimensionsObjects.length) {
                this.state.errorString = "Duplicated rows in the table of aggregation dimensions!";
                this.state.isUserInputsValid = false;
                return false;
            }

            let dimensions = [];

            for (let dim of userData.aggregationDimensions) {
                dimensions.push(dim);
            }

            userData.aggregationDimensions = dimensions;
        }
        this.state.isUserInputsValid = true;
        return true;
    }

    getDatagroupParams = (params) => {
        this.state.dataGroupParams = params;
        this.state.basicDataChanged = params.unsavedChanges;
        this.checkForUnsavedChanges();
    };

    getAggregates = (params) => {
        this.setState({ aggregates: cloneDeep(params) });
        if (this.state.editMode) {
            let editDataGroupUpdate = cloneDeep(this.state.editDataGroup);
            editDataGroupUpdate.attributesAndAggregationTypes = params.attributesAndAggregationTypes;
            this.setState({ editDataGroup: editDataGroupUpdate });
        }
        this.setState({ aggregatesDataChanged: params.unsavedChanges });
        this.checkForUnsavedChanges();
    };

    getDimensions = (params) => {
        this.setState({ dimensions: cloneDeep(params) });

        if (this.state.editMode) {
            let dims = [];
            params.aggregationDimensions.forEach(function (item) {
                dims.push(item)
            });
            let editDataGroupUpdate = cloneDeep(this.state.editDataGroup);
            editDataGroupUpdate.aggregationDimensions = dims;
            this.setState({ editDataGroup: editDataGroupUpdate });
        }
        this.setState({ dimensionsDataChanged: params.unsavedChanges });
        this.checkForUnsavedChanges();
    };

    checkForUnsavedChanges() {
        let changes = this.state.basicDataChanged || this.state.aggregatesDataChanged ||
            this.state.dimensionsDataChanged || this.state.sampleDataChanged;
        if (this.state.unsavedChanges !== changes) {
            let oldState = { ...this.state };
            oldState.unsavedChanges = changes;
            if (changes) {
                window.addEventListener("beforeunload", this.onUnload);
            }
            else if (changes === false) {
                window.removeEventListener("beforeunload", this.onUnload);
            }

            this.setState(oldState);
        }
    }

    initSave = () => {
        let { dataGroupParams, editMode, replayableRecords } = this.state;
        if (editMode) {
            if (dataGroupParams.status && replayableRecords !== 0) {
                this.setState({
                    modalMessage: `You have ${replayableRecords.toLocaleString("en-US")} records available for replay. Do you want to replay them?`,
                    show: true,
                    modalAction: "saveReplay"
                });
            } else {
                this.handleSaveGroup();
            }
        } else {
            this.handleSaveGroup();
        }
    }

    handleSaveGroup() {
        let { state } = this;
        let userData = {};

        if (state.editMode) {
            userData = this.updateStateData(userData, state);
        } else {
            userData = {
                name: state.dataGroupParams.name,
                code: '',
                sampleData: state.sampleData,
                status: state.dataGroupParams.status,
                timezone: state.dataGroupParams.timezone,
                aggregationTimeBuckets: state.dataGroupParams.aggregationTimeBuckets,
                attributesAndAggregationTypes: state.aggregates.attributesAndAggregationTypes,
                aggregationDimensions: state.dimensions.aggregationDimensions,
                realTimeInterval: state.dataGroupParams.aggregationTimeBuckets.find(e => e.id === 9) ? this.state.realTimeInterval : null,
            };
        }

        if (this.validateUserInput(userData)) {
            if (state.editMode) {
                this.updateDataGroup(userData);
            } else {
                this.createDataGroup(userData);
            }
        } else {
            this.forceUpdate();
        }
    }

    updateStateData = (userData, state) => {
        let { savedGroupData, aggregatesDataChanged, dimensionsDataChanged, sampleDataChanged } = this.state;

        userData["id"] = state.editDataGroup.id;
        userData["realTimeInterval"] = state.dataGroupParams.aggregationTimeBuckets.find(e => e.id === 9) ? this.state.realTimeInterval : null;
        if (savedGroupData.name !== state.dataGroupParams.name) {
            userData["name"] = state.dataGroupParams.name;
        }
        if (state.dataGroupParams.changedTimeBuckets) {
            userData["aggregationTimeBuckets"] = state.dataGroupParams.aggregationTimeBuckets;
        }
        if (savedGroupData.status !== state.dataGroupParams.status) {
            userData["status"] = state.dataGroupParams.status;
        }
        if (savedGroupData.timezone !== state.dataGroupParams.timezone) {
            userData["timezone"] = state.dataGroupParams.timezone;
        }
        if (aggregatesDataChanged) {
            userData["attributesAndAggregationTypes"] = state.aggregates.attributesAndAggregationTypes;
        }
        if (isEmpty(this.state.attributes)) {
            userData["attributesAndAggregationTypes"] = [];
        }
        else if (isEmpty(state.aggregates) || (state.aggregates.attributesAndAggregationTypes && isEmpty(state.aggregates.attributesAndAggregationTypes))) {
            userData["attributesAndAggregationTypes"] = [];
        }

        if (dimensionsDataChanged) {
            userData["aggregationDimensions"] = state.dimensions.aggregationDimensions;
        }
        if (isEmpty(this.state.attributes)) {
            userData["aggregationDimensions"] = [];
        }
        else if (isEmpty(state.dimensions) || (state.dimensions.aggregationDimensions && isEmpty(state.dimensions.aggregationDimensions))) {
            userData["aggregationDimensions"] = [];
        }

        if (sampleDataChanged) {
            userData["sampleData"] = state.sampleData;
        }

        return userData;
    }

    handleDeleteGroup(dataOnly, event, deleteRecorderData) {
        let params = {
            dataOnly: dataOnly,
            id: this.state.groupId,
            props: this.props,
            deleteRecorderData: deleteRecorderData
        };

        this.deleteDataGroup(params);
    }

    handleCloneGroup() {
        if (this.state.unsavedChanges) {
            let oldState = { ...this.state };
            oldState.modalMessage = "Data group has been edited. Please save the changes before cloning or testing the data group!";
            oldState.show = true;
            this.setState(oldState);
        } else {
            this.cloneDataGroup({
                id: this.state.groupId,
                props: this.props
            });
        }
    }

    handleTestGroup() {
        if (this.state.unsavedChanges) {
            let oldState = { ...this.state };
            oldState.modalMessage = "Data group has been edited. Please save the changes before cloning or testing the data group!";
            oldState.show = true;
            this.setState(oldState);
        } else {
            let cookieExpiry = Date.now() + 60 * 1000;
            let currentUrl = window.location.href;

            if (currentUrl.includes("localhost")) {
                cookies.set('group_name', this.state.editDataGroup.name, { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('payload', JSON.stringify(this.state.sampleData), { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('access_token', localStorage.getItem("access_token"), { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('refresh_token', localStorage.getItem("refresh_token"), { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('target_url', this.state.dataGroupParams.url, { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('user_id', this.state.userId, { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('account_id', this.state.accountId, { path: '/', expires: new Date(cookieExpiry) });
                cookies.set('account_url', this.state.groupUrl, { path: '/', expires: new Date(cookieExpiry) });
                window.open('http://localhost:4000/#/new-config');
            } else {
                cookies.set('group_name', this.state.editDataGroup.name, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('payload', JSON.stringify(this.state.sampleData), { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('access_token', localStorage.getItem("access_token"), { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('refresh_token', localStorage.getItem("refresh_token"), { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('target_url', this.state.dataGroupParams.url, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('user_id', this.state.userId, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('account_id', this.state.accountId, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
                cookies.set('account_url', this.state.groupUrl, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });

                if (currentUrl.includes("elb.kanin.io") || currentUrl.includes("dev.kanin.io")) {
                    window.open('https://loadergun-dev.kanin.io/#/new-config', '_blank');
                } else if (currentUrl.includes("qa.kanin.io")) {
                    window.open('https://loadergun-qa.kanin.io/#/new-config', '_blank');
                } else {
                    window.open('https://loadergun.kanin.io/#/new-config', '_blank');
                }
            }
        }
    }

    handleHideModal() {
        this.setState({ show: false });
        this.forceUpdate();
    }

    handleRealTimeChange = (event) => {
        this.setState({realTimeInterval: event.target.value});
    }

    openEditGroupModal = () => {
        this.setState({
            modalMessage: 'Your existing data will be deleted, but you can replay your previous data! Do you want to proceed?',
            show: true,
            modalAction: "edit"
        });
    };

    closeEditGroupModal = () => {
        this.setState({
            show: false,
            modalMesasge: ''
        }, () => {
            this.setState({ editModal: false });
        });
    }

    // Delete existing records for the data group.
    deleteData = () => {
        let { editDataGroup } = this.state;
        let userData = {
            "id": editDataGroup.id,
            //"status": "inactive"
        };
        this.setState({ show: false, modalMessage: '', forbidAllActions: true, modalAction: '' });
        this.updateDataGroupActivity(userData)
            .then(result => {
                this.setState({ editStatusProgramatically: false, dataGroupStatus: '' });
                let deleteParams = {
                    dataOnly: true,
                    id: this.state.groupId
                };
                this.deleteDataGroup(deleteParams);
            })
            .catch(error => {
                this.setState({ forbidAllActions: false });
                this.getError(error);
            });

    }

    updateDataGroupActivity = (userData) => {
        let qs = require('qs');
        let accessToken = localStorage.getItem("access_token");
        let updateActivityRes = axiosInstance.put(EndpointsGetter.getDataGroupEndpoint(), qs.parse(userData), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(updateRes => {
                let newState = { ...this.state };
                newState.editModal = false;
                newState.show = false;
                newState.editDataGroup = { ...updateRes.data, editMode: false };
                newState.savedGroupData = cloneDeep(updateRes.data);
                newState.unsavedChanges = false;
                newState.aggregatesDataChanged = false;
                newState.dimensionsDataChanged = false;
                newState.basicDataChanged = false;
                newState.sampleDataChanged = false;
                //newState.editStatusProgramatically = true;
                //newState.dataGroupStatus = 'inactive';

                this.setState(newState);
                this.setAttributesAndSampleData();
                return updateRes.data;
            });

        return updateActivityRes;
    }

    initDataReplay = () => {
        let { unsavedChanges } = this.state;
        if (unsavedChanges) {
            this.setState({
                modalMessage: 'To replay your old data you have to save your changes. Do you want to save them?',
                show: true,
                modalAction: "replaySave"
            });
        } else {
            this.saveAndReplayData();
        }
    }

    saveAndReplayData = () => {
        let userData = this.updateStateData({}, this.state);
        userData.status = "active";
        this.setState({ show: false, modalMessage: '', forbidAllActions: true, modalAction: '' });

        if (this.validateUserInput(userData)) {
            this.updateDataGroup(userData, true)
                .then(saveResult => {
                    if (saveResult) {
                        this.setState({ editStatusProgramatically: false, dataGroupStatus: '' });
                        this.replayData(saveResult.id);
                    }
                })
        } else {
            this.setState({ forbidAllActions: false });
        }
    }

    replayData = (groupId) => {
        let accessToken = localStorage.getItem('access_token');
        let replayPromise = axiosInstance.get(`${EndpointsGetter.getDataGroupEndpoint()}/replay/${groupId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(replayResult => {
                this.setState({
                    forbidAllActions: false,
                    replayableRecords: 0,
                    show: true,
                    modalMessage: "Data group configuration and data were saved and replayed successfully!"
                });
            })
            .catch(error => {
                this.setState({ forbidAllActions: false });
                this.getError(error);
            })

        return replayPromise;
    }

    approveModalAction = () => {
        let { modalAction } = this.state;
        switch (modalAction) {
            case 'edit':
                //edit mode
                this.deleteData();
                break;
            case 'replaySave':
                //when the user clicks on replay, but has unsaved changes.
                this.saveAndReplayData();
                break;
            case 'saveReplay':
                //when the user clicks on save and has the opportunity to replay.
                this.saveAndReplayData();
                break;
            default:
                break;
        }
    }

    disapproveModalAction = () => {
        if (this.state.modalAction === 'saveReplay') {
            this.handleSaveGroup();
        }
        this.setState({
            show: false,
            modalMesasge: ''
        }, () => {
            this.setState({ modalAction: "" });
        });
    }

    render() {
        const { match, location, history, classes } = this.props;
        let { editMode, records, editModal, editStatusProgramatically, replayableRecords, dataGroupStatus, editDataGroup, modalAction } = this.state;

        return (
            <div>
                {this.state.forbidAllActions ? <CircularProgress className={classNames(classes.circularProgress, classes.progress)} color="secondary" /> : null}
                <div style={{ pointerEvents: this.state.forbidAllActions ? 'none' : 'auto', 'filter': this.state.forbidAllActions ? 'blur(1px)' : 'blur(0px)' }}>
                    <FusePageSimple
                        header={
                            <div className='header-container'>
                                <h3 className='header-title'>{editMode ? "Edit" : "Define"} Data Group</h3>
                                <div className="flex flex-1 px-24">
                                </div>
                                <div className="header-buttons" style={{ marginRight: 10 }}>
                                    {editMode && editDataGroup.editMode ? (
                                        <Fragment>
                                            <button className="header-button btn btn-primary" onClick={this.openEditGroupModal}>
                                                Edit
                                            </button>
                                        </Fragment>
                                    ) : null}
                                    <button className="header-button btn btn-primary"
                                        onClick={this.initSave}>
                                        Save
                                    </button>
                                    {editMode ?
                                        <div>
                                            <button className="header-button btn btn-success"
                                                onClick={(e) => this.handleTestGroup()}>
                                                Test
                                            </button>
                                            {
                                                this.state.records != null && this.state.records > 0 ?
                                                    <Link to={{
                                                        pathname: '/query-group/' + this.state.groupId
                                                    }}>
                                                        <button className="header-button btn btn-info">
                                                            Query
                                                        </button>
                                                    </Link> : null
                                            }
                                            <button className="header-button btn btn-warning"
                                                onClick={(e) => this.handleCloneGroup()}>
                                                Clone
                                            </button>
                                            <div className="btn-group">
                                                <button type="button"
                                                    className="btn btn-danger dropdown-toggle trigger-btn"
                                                    data-toggle="dropdown">
                                                    Delete <span className="caret"></span>
                                                </button>
                                                <ul className="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                        <a href="#deleteDataModal" data-target="#deleteDataModal" data-toggle="modal"
                                                            onClick={(e) => {
                                                                let modal = document.getElementById('deleteDataModal');
                                                                document.body.appendChild(modal);
                                                            }
                                                            }>Only group's data</a>
                                                    </li>
                                                    <li>
                                                        <a href="#deleteGroupModal" data-target="#deleteGroupModal" data-toggle="modal"
                                                            onClick={(e) => {
                                                                let modal = document.getElementById('deleteGroupModal');
                                                                document.body.appendChild(modal);
                                                            }
                                                            }>All (data and configuration)</a>
                                                    </li>
                                                    <li>
                                                        <a href="#deleteDataCompletelyModal" data-target="#deleteDataCompletelyModal" data-toggle="modal"
                                                            onClick={(e) => {
                                                                let modal = document.getElementById('deleteDataCompletelyModal');
                                                                document.body.appendChild(modal);
                                                            }
                                                            }>Data group's data including replay data</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        }
                        content={
                            <div className="container-fluid">
                                {this.state.records != null && this.state.records > 0 ?
                                    <div className="alert alert-warning alert-dismissible" style={{ marginTop: 20 }}
                                        role="alert">
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <strong>Warning!</strong> There is data generated for the Data Group. You need
                                        to delete the data in order to make any changes on the payload settings.
                                    </div> : null
                                }
                                {!this.state.isUserInputsValid ?
                                    <div className="screen-layout">
                                        <label className="text-area-label"
                                            style={{ color: 'red' }}>{this.state.errorString}</label>
                                    </div>
                                    : null
                                }
                                <div className="row screen-layout">
                                    {replayableRecords !== 0 ? (
                                        <div className='replay-section'>
                                            <div className='replay-panel'>
                                                <Toolbar style={{ minHeight: '54px', padding: '0 15px' }} variant="dense">
                                                    <FormLabel style={{ marginRight: '10px', marginBottom: '2px' }}>
                                                        {`You have ${replayableRecords.toLocaleString("en-US")} records available for replay`}
                                                    </FormLabel>
                                                    <Button variant="contained" className='replay-button' color='primary' onClick={this.initDataReplay}>
                                                        Replay
                                                    </Button>
                                                </Toolbar>
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="col-lg-8 col-sm-12">
                                        <DefinitionControls editDataGroupParams={this.state.editDataGroup}
                                            savedGroup={this.state.savedGroupData}
                                            timezones={this.state.timezones}
                                            accountParameters={this.state.accountParameters}
                                            paramsCallback={this.getDatagroupParams}
                                            editStatusProgramatically={editStatusProgramatically}
                                            dataGroupStatus={dataGroupStatus}
                                            realTimeInterval={this.state.realTimeInterval}
                                            handleRealTimeChange={this.handleRealTimeChange}
                                        />
                                        <br />
                                        <AggregatesTable editDataGroupParams={this.state.editDataGroup}
                                            savedGroup={this.state.savedGroupData}
                                            aggTypes={this.state.aggTypes}
                                            attributes={this.state.attributes}
                                            aggregatesCallback={this.getAggregates}
                                            clientLimitExceeded={(type) => this.clientLimitExceeded(type, this.state.aggregationsLimit)}
                                            aggregationsLimit={this.state.aggregationsLimit} />
                                        <br /><br />
                                        <DimensionsTable editDataGroupParams={this.state.editDataGroup}
                                            savedGroup={this.state.savedGroupData}
                                            attributes={this.state.attributes}
                                            dimensionsCallback={this.getDimensions}
                                            clientLimitExceeded={(type) => this.clientLimitExceeded(type, this.state.dimensionsLimit)}
                                            dimensionsLimit={this.state.dimensionsLimit} />
                                    </div>
                                    <div className="col-lg-4 col-sm-12">
                                        <label htmlFor="sample-data-textarea" className="text-area-label col-lg-6">Sample
                                            Data</label>
                                        <label htmlFor="sample-data-textarea" className="text-area-label col-lg-6"
                                            style={{ color: 'red' }}>{this.state.invalidDataFormatMessage}</label>
                                        <textarea id="sample-data-textarea"
                                            rows="35"
                                            className={classNames(classes.textArea, "form-control", "rounded-0")}
                                            style={this.state.invalidFormatAreaStyle}
                                            value={this.state.sampleDataValue}
                                            readOnly={editDataGroup.editMode}
                                            onBlur={() => this.handleSampleDataBlur()}
                                            onChange={(evt) => {
                                                this.handleSampleDataChange(evt)
                                            }}
                                        />
                                    </div>
                                </div>
                                <div id="deleteDataModal" className="modal fade" role="dialog">
                                    <div className="modal-dialog modal-confirm">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Are you sure?
                                                    <button type="button" className="close" data-dismiss="modal"
                                                        aria-hidden="true">&times;</button>
                                                </h4>
                                            </div>
                                            <div className="modal-body">
                                                <p>You are about to delete only the data of this data group. This
                                                    process cannot
                                                    be undone.</p>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-info"
                                                    data-dismiss="modal">Cancel
                                                </button>
                                                <button type="button" className="btn btn-danger"
                                                    onClick={(e) => this.handleDeleteGroup(true, e, false)}
                                                    data-dismiss="modal">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="deleteGroupModal" className="modal fade" role="dialog">
                                    <div className="modal-dialog modal-confirm">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Are you sure?
                                                    <button type="button" className="close" data-dismiss="modal"
                                                        aria-hidden="true">&times;</button>
                                                </h4>
                                            </div>
                                            <div className="modal-body">
                                                <p>You are about to delete the whole data group (data and
                                                    configuration). This
                                                    process cannot be undone.</p>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-info"
                                                    data-dismiss="modal">Cancel
                                                </button>
                                                <button type="button" className="btn btn-danger"
                                                    onClick={(e) => this.handleDeleteGroup(false, e, false)}
                                                    data-dismiss="modal">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="deleteDataCompletelyModal" className="modal fade" role="dialog">
                                    <div className="modal-dialog modal-confirm">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Are you sure?
                                                    <button type="button" className="close" data-dismiss="modal"
                                                        aria-hidden="true">&times;</button>
                                                </h4>
                                            </div>
                                            <div className="modal-body">
                                                <p>You are about to delete this data group's data completely including stored replay entries. This
                                                    process cannot be undone.</p>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-info"
                                                    data-dismiss="modal">Cancel
                                                </button>
                                                <button type="button" className="btn btn-danger"
                                                    onClick={(e) => this.handleDeleteGroup(true, e, true)}
                                                    data-dismiss="modal">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Modal
                                    show={this.state.show}
                                    onHide={this.handleHide}
                                    container={this}
                                    aria-labelledby="contained-modal-title"
                                >
                                    <Modal.Header>
                                        <Modal.Title id="contained-modal-title">
                                            Message
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {this.state.modalMessage}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        {modalAction ? (
                                            <Fragment>
                                                <button type="button" className="btn btn-success" onClick={this.approveModalAction}>
                                                    YES
                                                </button>
                                                <button type="button" className="btn btn-danger" onClick={this.disapproveModalAction}>
                                                    NO
                                                </button>
                                            </Fragment>
                                        ) : (
                                                <button type="button" className="btn btn-info" onClick={() => this.handleHideModal()}>
                                                    OK
                                                </button>
                                            )}
                                    </Modal.Footer>
                                </Modal>
                                {
                                    this.state.unsavedChanges ?
                                        <Prompt
                                            when={this.props.navigationBlocked}
                                            message="You have unsaved changes. Are you sure you want to leave?"
                                        />
                                        : null
                                }
                            </div>
                        }
                    />
                </div>
            </div>

        );
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(DefineDataGroup));


// WEBPACK FOOTER //
// ./src/main/content/define-data-group/DefineDataGroup.js